import React from 'react';

import { View403 } from "src/sections/error";
import { hasUserAccess } from "../context/jwt";

export default function AccessGuard({ children, policies }) {

  return hasUserAccess(policies) ? <>{children}</> : <View403/>;
}
